module.exports = __webpack_public_path__ + "img/full7-min.1bc7af9e.png";